<template>
  <g>
    <annotation-ellipse v-if="isEllipse" :annotation="annotation" :scale="scale" />
    <annotation-circle v-if="isCircle" :annotation="annotation" :scale="scale" />
    <annotation-polyline v-if="isPolyline" :annotation="annotation" :scale="scale" />
    <annotation-overlay-mask v-if="isOverlayMask" :annotation="annotation" :scale="scale" />
  </g>
</template>

<script>
  import { AnnotationResource } from '@/api-resources';
  import AnnotationEllipse from '@/Atoms/AnnotationEllipse';
  import AnnotationCircle from '@/Atoms/AnnotationCircle';
  import AnnotationPolyline from '@/Atoms/AnnotationPolyline';
  import AnnotationOverlayMask from '@/Atoms/AnnotationOverlayMask';

  export default {
    name: 'AnnotationGraphic',

    components: {
      AnnotationEllipse,
      AnnotationCircle,
      AnnotationPolyline,
      AnnotationOverlayMask,
    },

    props: {
      annotation: AnnotationResource,
      scale: Number,
    },

    computed: {
      isEllipse() {
        return this.annotation.graphicType === 'ELLIPSE';
      },

      isCircle() {
        return this.annotation.graphicType === 'CIRCLE';
      },

      isPolyline() {
        return this.annotation.graphicType === 'POLYLINE';
      },

      isOverlayMask() {
        return this.annotation.graphicType === 'MASK';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/config/variables';

  g {
    opacity: 0.8;
    stroke-opacity: 0.8;
    stroke-linecap: round;
    transition: $ease-effect;

    &:hover {
      opacity: 1;
      stroke-opacity: 1;
    }
  }
</style>
